import { AudioRepository } from "app/js/src/domain/audio-repository";
import { MediaRepository } from "app/js/src/domain/media-repository";

/** Resolved default (first) linked audio track for a video media item. */
export interface ClippingStudioDefaultAudio {
  defaultAudioMediaId: number;
  defaultAudioPreviewUrl: string;
}

/**
 * Resolves the first linked audio track for a video media id via
 * getMediaInfo → audioFiles[0].id → getAudioURL(id).
 * Returns null when the media has no linked audio (embedded-only).
 */
export async function resolveDefaultAudioForMedia(
  mediaId: number,
  mediaRepository: MediaRepository,
  audioRepository: AudioRepository,
): Promise<ClippingStudioDefaultAudio | null> {
  if (mediaId == null || mediaId <= 0) {
    return null;
  }
  try {
    const info = await mediaRepository.getMediaInfo(mediaId);
    const first = info?.audioFiles?.[0];
    if (first?.id == null || first.id <= 0) {
      return null;
    }
    const response = await audioRepository.getAudioURL(first.id);
    const url =
      (response && (response.url ?? response.Url)) != null
        ? String(response.url ?? response.Url)
        : "";
    if (!url.trim()) {
      return null;
    }
    return {
      defaultAudioMediaId: first.id,
      defaultAudioPreviewUrl: url,
    };
  } catch {
    return null;
  }
}
